/* eslint-disable */
const filters = {
  /**
   * 字典过滤
   * @param val {Number, String} 需转换的值
   * @param fields {Array} 查找的字段集合 [{label, value}]
   * @return {String} 转换值对应的label字段
   */
  field (val, fields) {
    let field
    if (!val && val !== 0){
      console.error(`需过滤的数据为${val}`, fields)
      return val
    } else if (!fields instanceof Array) {
      console.error('过滤的查询数据不为数组')
      return val
    } else if (fields instanceof Array && !fields.length) {
      console.error('过滤的查询数据数组为空')
      return val
    }
    try {
      field = fields.find(item => item.id === val)
      return field ? field.name : val
    }
    catch (err) {
      console.error(err)
      return val
    }
  }
}
export default {
  install (Vue) {
    for (const key in filters) {
      Vue.filter(key, filters[key])
    }
  }
}
